module.exports = __webpack_public_path__ + "static/Chevrolet-logo-59e6adc41dc2c973db97819039b0aab6.png";